import { Controller } from "@hotwired/stimulus";

// Put on a select. Shows only the rows (selector in `rows`, attribute
// `data-level`) of the registration level picked; the empty option shows all.
export default class extends Controller {
  static values = {rows: String};

  filter() {
    const level = this.element.value;
    document.querySelectorAll(this.rowsValue).forEach((row) => {
      row.hidden = level !== "" && row.dataset.level !== level;
    });
  }
}
